import React from 'react';
import locationred from '../../../icons/locationred.png';
import locationwhite from '../../../icons/locationwhite.png';

const Tabs = ({toggle, setToggle, tabs}) => {
    return (
        <div>
            <ul className="tabs-component">
                {
                    tabs.map((item, index) => {
                        return item.type === "text" ? (
                        <li key={index}>
                            <button onClick={() => setToggle(item.id)} className={toggle === item.id ? 'active' : ''}>{item.title}</button>
                        </li>
                        ) : (
                            <li key={index}>
                                <button onClick={() => setToggle(item.id)} className={toggle == item.id ? 'active' : ''}><img src={toggle == item.id ? locationwhite : locationred} alt="404"/></button>
                            </li>
                        )
                    })
                }
                {/*<li>*/}
                {/*    <button onClick={() => setToggle(1)} className={toggle == 1 ? 'active' : ''}>1-Jadval</button>*/}
                {/*</li>*/}
                {/*<li>*/}
                {/*    <button onClick={() => setToggle(2)} className={toggle == 2 ? 'active' : ''}>2-Jadval</button>*/}
                {/*</li>*/}
                {/*<li>*/}
                {/*    <button onClick={() => setToggle(3)} className={toggle == 3 ? 'active' : ''}>3-Jadval</button>*/}
                {/*</li>*/}
                {/*<li>*/}
                {/*    <button onClick={() => setToggle(4)} className={toggle == 4 ? 'active' : ''}><img src={locationred} alt="404"/></button>*/}
                {/*</li>*/}
            </ul>
        </div>
    );
};

export default Tabs;